import styles from '@components/components/HeatInstallationForm/components/PreCheck/PreCheck.module.scss';
import ActionFooter from '@components/components/HeatInstallationForm/components/ActionFooter';
import InlineInfo from '@components/components/HeatInstallationForm/components/InlineInfo';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  Container,
  FontAwesomeProIcon,
  Heading,
  IconCard,
  IconText,
  Link,
  Radio,
} from '@wienenergiegithub/ui-next';
import { FormLabel, FormRadio, FormRadioGroup } from '@ariakit/react';

const PreCheck = ({
  store,
  step,
  isGeneralRecommender,
  handleGeneralNextStep,
  handleGeneralPrevStep,
  handleSkipStep,
  setNextValidStep,
}) => {
  const isOwner = store.useValue('isOwner');

  return (
    <>
      <Container size="lg">
        <Heading className={styles.semi} size="h2">
          {isGeneralRecommender
            ? 'Ihre Wärme Nachinstallation (1/4)'
            : 'An Ihrer Adresse ist ein nachträglicher Einbau von Fernwärme möglich.'}
        </Heading>
        <Card className={styles.container}>
          <CardBody className={styles.cardBody}>
            <FormRadioGroup
              className={styles.isOwner}
              name="isOwner"
              store={store}
            >
              <FormLabel
                className={styles.radioLabel}
                name="isOwner"
                render={<legend />}
                store={store}
              >
                <Heading notResponsive size="h6">
                  Sind Sie an dieser Adresse Hauptmieter*in und/oder
                  Wohnungseigentümer*in?
                </Heading>
              </FormLabel>

              <div className={styles.radios}>
                <FormRadio
                  label="Ja"
                  name="isOwner"
                  onChange={e => e.target.blur()}
                  render={<Radio label="Ja" />}
                  required
                  store={store}
                  value="Ja"
                  variant="horizontal"
                />
                <FormRadio
                  label="Nein"
                  name="isOwner"
                  onChange={e => e.target.blur()}
                  render={<Radio label="Nein" />}
                  required
                  store={store}
                  value="Nein"
                  variant="horizontal"
                />
              </div>
            </FormRadioGroup>
            {isOwner === 'Ja' && (
              <InlineInfo
                className={styles.inlineInfo}
                content="Fragen Sie eine Kostenkalkulation für Ihre Wärme Nachinstallation an und vereinbaren Sie ein unverbindliches Beratungsgespräch!"
                icon="circle-info"
              />
            )}
            {isOwner === 'Nein' && (
              <InlineInfo
                className={styles.inlineInfo}
                content="Wenn Sie mit Fernwärme versorgt werden möchten, wenden Sie
                 	 sich bitte an Ihre/n VermieterIn und/oder HauseigentümerIn."
                icon="circle-info"
              />
            )}
            {!isGeneralRecommender && (
              <ActionFooter
                nextText="Berechnung starten"
                setNextValidStep={setNextValidStep}
                step={step}
                stepName="eigentum"
                store={store}
              />
            )}
          </CardBody>
        </Card>
        {isGeneralRecommender && (
          <ActionFooter
            handleGeneralNextStep={handleGeneralNextStep}
            handleGeneralPrevStep={handleGeneralPrevStep}
            handleSkipStep={handleSkipStep}
            isGeneralRecommender={isGeneralRecommender}
            nextText="Berechnung starten"
            setNextValidStep={setNextValidStep}
            step={step}
            stepName="eigentum"
            store={store}
          />
        )}
      </Container>
      <Container size="full">
        {isOwner === 'Nein' && (
          <>
            <Heading className={styles.outerHeadline} size="h2">
              Noch Fragen? Wir sind für Sie da!
            </Heading>

            <Button
              isElevated
              render={
                <Link
                  className={styles.ctaButton}
                  data-purpose="heat-installation-form-contactbutton"
                  to="tel:0800500704"
                >
                  <FontAwesomeProIcon
                    className={styles.ctaButtonIcon}
                    icon="phone"
                    role="presentation"
                    type="regular"
                  />
                  Serviceline: 0800 500 704
                </Link>
              }
              shape="squared"
              theme="contrast"
            />
          </>
        )}
        {isOwner !== 'Nein' && (
          <>
            <Heading className={styles.outerHeadline} size="h2">
              Vorteile einer Nachinstallation
            </Heading>
            {!isGeneralRecommender && (
              <div className={styles.gridCol3}>
                <IconCard
                  description="Fernwärme ist immer bereit, wenn Sie Warmwasser und Heizwärme brauchen."
                  glyph="hands-heart"
                  headingSize="h6"
                  title="Sicher"
                  variant="iconTop"
                />
                <IconCard
                  description="Fernwärme erzeugen wir in modernsten Anlagen direkt in Wien. So sparen wir wertvolle Rohstoffe und CO₂."
                  glyph="flower-daffodil"
                  headingSize="h6"
                  title="Umwelt&shy;freundlich"
                  variant="iconTop"
                />
                <IconCard
                  description="Fernwärme spart Zeit und Geld, da Wartungs- und Servicekosten für Brenner, Thermen und Kamin entfallen."
                  glyph="piggy-bank"
                  headingSize="h6"
                  title="Bequem"
                  variant="iconTop"
                />
              </div>
            )}
            {isGeneralRecommender && (
              <div className={styles.gridCol3}>
                <IconText
                  glyph="hands-heart"
                  heading="Sicher"
                  text="Fernwärme ist immer bereit, wenn Sie Warmwasser und Heizwärme brauchen."
                />
                <IconText
                  glyph="flower-daffodil"
                  heading="Umwelt&shy;freundlich"
                  text="Fernwärme erzeugen wir in modernsten Anlagen direkt in Wien. So sparen wir wertvolle Rohstoffe und CO₂."
                />
                <IconText
                  glyph="piggy-bank"
                  heading="Bequem"
                  text="Fernwärme spart Zeit und Geld, da Wartungs- und Servicekosten für Brenner, Thermen und Kamin entfallen."
                />
              </div>
            )}
          </>
        )}
      </Container>
    </>
  );
};

export default PreCheck;
